import { JsonUtils } from '../../utils/json.util'
export enum AgeGroup {
    MENOS_DE_18 = 'menos de 18',
    DE_18_A_29 = '18-29',
    DE_30_A_39 = '30-39',
    DE_40_A_49 = '40-49',
    DE_50_A_59 = '50-59',
    MAIS_DE_60 = '60 ou mais'
}

export enum FamilyHistory {
    SIM = 'Sim',
    NAO = 'Não',
    NAO_SEI = 'Não sei'
}

export enum LastMammogram {
    MENOS_DE_UM_ANO = 'menos de um ano',
    MAIS_DE_UM_ANO = 'mais de um ano',
    NUNCA_FIZ = 'nunca fiz'
}
export class Questionnaire {
    private _recent_breast_change: boolean | undefined
    private _has_lump: boolean | undefined
    private _breast_cancer_diagnosed: boolean | undefined
    private _had_mammogram: boolean | undefined
    private _last_mammogram_date: LastMammogram | undefined
    private _family_history_breast_cancer: FamilyHistory | undefined
    private _age_group: AgeGroup | undefined
    private _spontaneous_nipple_discharge: boolean | undefined

    get recentBreastChange(): boolean | undefined {
        return this._recent_breast_change
    }

    set recentBreastChange(value: boolean | undefined) {
        this._recent_breast_change = value
    }

    get hasLump(): boolean | undefined {
        return this._has_lump
    }

    set hasLump(value: boolean | undefined) {
        this._has_lump = value
    }

    get breastCancerDiagnosed(): boolean | undefined {
        return this._breast_cancer_diagnosed
    }

    set breastCancerDiagnosed(value: boolean | undefined) {
        this._breast_cancer_diagnosed = value
    }
    get hadMammogram(): boolean | undefined {
        return this._had_mammogram
    }

    set hadMammogram(value: boolean | undefined) {
        this._had_mammogram = value
    }
    get lastMammogranDate(): LastMammogram | undefined {
        return this._last_mammogram_date
    }
    set lastMammogranDate(value: LastMammogram | undefined) {
        this._last_mammogram_date = value
    }
    get familyHistoryBreastCancer(): FamilyHistory | undefined {
        return this._family_history_breast_cancer
    }

    set familyHistoryBreastCancer(value: FamilyHistory | undefined) {
        this._family_history_breast_cancer = value
    }
    get ageGroup(): AgeGroup | undefined {
        return this._age_group
    }

    set ageGroup(value: AgeGroup | undefined) {
        this._age_group = value
    }
    get spontaneousNippleDischarge(): boolean | undefined {
        return this._spontaneous_nipple_discharge
    }

    set spontaneousNippleDischarge(value: boolean | undefined) {
        this._spontaneous_nipple_discharge = value
    }


    public fromJSON(json: any): Questionnaire {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        if (json.recent_breast_change !== undefined) {
            this.recentBreastChange = json.recent_breast_change
        }
        if (json.has_lump !== undefined) {
            this.hasLump = json.has_lump
        }
        if (json.breast_cancer_diagnosed !== undefined) {
            this.breastCancerDiagnosed = json.breast_cancer_diagnosed
        }
        if (json.had_mammogram !== undefined) {
            this.hadMammogram = json.had_mammogram
        }
        if (json.last_mammogram_date !== undefined) {
            this.lastMammogranDate = json.last_mammogram_date
        }
        if (json.family_history_breast_cancer !== undefined) {
            this.familyHistoryBreastCancer = json.family_history_breast_cancer
        }
        if (json.age_group !== undefined) {
            this.ageGroup = json.age_group
        }
        if (json.spontaneous_nipple_discharge !== undefined) {
            this.spontaneousNippleDischarge = json.spontaneous_nipple_discharge
        }
        return this
    }
    public toJSON(): any {
        return {
            recentBreastChange: this.recentBreastChange || undefined,
            hasLump: this.hasLump || undefined,
            breastCancerDiagnosed: this.breastCancerDiagnosed || undefined,
            hadMammogram: this.hadMammogram || undefined,
            lastMammogranDate: this.lastMammogranDate || undefined,
            familyHistoryBreastCancer: this.familyHistoryBreastCancer || undefined,
            ageGroup: this.ageGroup || undefined,
            spontaneousNippleDischarge: this.spontaneousNippleDischarge || undefined,
        }
    }


}